module.exports = __webpack_public_path__ + "img/device_1014_2.4845c2f3.svg";